$(document).ready(function() {
  // InitSlider();
  // AnchorButton();
  var L;
  var R;
  $(".menu-left details.mega-menu").mouseenter(
    function() {
      if(R){
        R.attr('open',false)
      }
      L = $(this);
      $(this).attr('open',true);
      $(this).parent().parent().prevAll().children().children().attr("open",false);
       $(this).parent().parent().nextAll().children().children().attr("open",false);
    }
 );

  $(".menu-right details.mega-menu").mouseenter(
    function() {
      if(L){
         L.attr('open',false);
      }
      R = $(this);
      $(this).attr('open',true);
      $(this).parent().parent().prevAll().children().children().attr("open",false);
       $(this).parent().parent().nextAll().children().children().attr("open",false);
    }
 );
 $(".header-top-sec").mouseenter(
    function() {
      if(L){
         L.attr('open',false);
      }
      if(R){
        R.attr('open',false)
      }
    });
  
 $(".details.mega-menu").mouseleave(
  function() {
  $(this).attr("open",false);
}
);

 $(".mega-menu__content").hover(
  function() {
    var openDetailsElement = $(this).parent('details');
      $(openDetailsElement).attr('open',true);
    },
    function() {
      var openDetailsElement = $(this).parent('details');
        $(openDetailsElement).attr('open',false);
      }
  );
 

});
 
const AnchorButton = function() {
  $(document).on('click', '[data-anchor-btn]', function() {
    var _class = $(this).attr('data-target');
    var $target = $('.' + _class);
    if($target.length > 0) {
      var top_x = $target.offset().top;
      $("html, body").animate({
        scrollTop: top_x
      }, 600);
    }
  })
}

$(document).ready(function() {
  $(document).on("click",".read-anchor",function(){
    
    console.log("click");
    $("#accrodian1").addClass("active");
    $("#accrodian1").next().css({display:'block'});
  });
});

$(document).ready(function() {
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
}); 


// more plus custom code

$(document).ready(function() {
  var alllenght= $('.row.product').find('.grid__item__less').find('.thumbnail-slider .thumbnail-list').find('.thumbnail-list__item').length;
//alert(alllenght);
  if ($(window).width() < 767){

var total= alllenght-2;
  if(alllenght>2){
 $('.row.product').find('.grid__item__less').find('.thumbnail-slider .thumbnail-list').find('.thumbnail-list__item').eq(2).addClass('slideractive');
 $('.row.product').find('.grid__item__less').find('.thumbnail-slider .thumbnail-list').find('.thumbnail-list__item').eq(2).append('<span class="moremessage">'+total+ '+ More</span>')
} else{
    $('.moremessage').remove();
 $('.row.product').find('.grid__item__less').find('.thumbnail-slider .thumbnail-list').find('.thumbnail-list__item').eq(2).removeClass('slideractive');   
}
$('.moremessage').click(function(){
  $('.slider-button.slider-button--next').trigger('click');
  setTimeout(function() {
  $('.moremessage').hide();
    }, 500);
  
});

}else{ 
var total= alllenght-5;
  if(alllenght>5){
 $('.row.product').find('.grid__item__less').find('.thumbnail-slider .thumbnail-list').find('.thumbnail-list__item').eq(4).addClass('slideractive');
 $('.row.product').find('.grid__item__less').find('.thumbnail-slider .thumbnail-list').find('.thumbnail-list__item').eq(4).append('<span class="moremessage">'+total+ '+ More</span>')
} else{
    $('.moremessage').remove();
 $('.row.product').find('.grid__item__less').find('.thumbnail-slider .thumbnail-list').find('.thumbnail-list__item').eq(4).removeClass('slideractive');   
}
$('.moremessage').click(function(){
  $('.slider-button.slider-button--next').trigger('click');
  setTimeout(function() {
  $('.moremessage').hide();
    }, 500);
  
});
$('.slider-button.slider-button--prev').click(function(){
 $('.moremessage').show();
});
    $('.slider-button.slider-button--next').click(function(){
 $('.moremessage').hide();
});


}
});




$ = jQuery
$(document).on('click', '.js-load-more', function () { 
    // $('.js-load-more').live('click', function(){
     var $this =$(this),
     totalPages = parseInt($('[data-all-pages]').val()),
     currentPage = parseInt($('[data-this-page]').val()),
     datacollurl = $('[data-coll-url]').val();
     $this.attr('disabled', true);
     $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide'); 
     var nextUrl = $('[data-next-link]').val();
     var current_page_new = currentPage + 1;
     var next_coll = currentPage + 2;
     //alert(current_page_new)
     //return false;
     $.ajax({
     url: nextUrl,
     type: 'GET',
     dataType: 'html',
     success: function(responseHTML){
     $('[data-next-link]').val(datacollurl + "?page="+next_coll);
     $('[data-this-page]').val(current_page_new);
     $('.product-grid').append($(responseHTML).find('.product-grid').html());
     },
     complete: function() {
     if(current_page_new < totalPages) {
     $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
     } 
     if(current_page_new >= totalPages) {
     $this.find('[load-more-text]').text('Products Finished').removeClass('hide'); $this.find('[loader]').addClass('hide');
     } 
     }
     })

    });

    var defaultsort = 'best-selling';
    $('body').on('click', 'input[name=sortBy_custom]', function(event) {
      console.log('clicked');
        if($(this).prop("checked") == true)
        {
          console.log('inside');

          defaultsort = $(this).val();
          console.log("in");
          console.log(defaultsort);
          $('#FacetFiltersForm .facet-filters.sorting .select select').val(defaultsort).change();
          $('#FacetFiltersForm .dummy').val(defaultsort);
           document.querySelector("#FacetFiltersForm .dummy").dispatchEvent(new Event('change'));
        //    setTimeout(function(){
        //     sortby();
        //   }, 2000);
        }
    });

    function getUrlParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    window.sortby = function (){
        console.log('function called');
    const sortByValue = getUrlParameter('sort_by');

    if (sortByValue) {
        $('input[name="sortBy_custom"]').each(function () {
            if ($(this).val() === sortByValue) {
                $(this).prop('checked', true);
            }
        });
    } else {
        $('input[name="sortBy_custom"]').first().prop('checked', true);
    }
}
sortby();